define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginMenu"
], function(declare,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		validatePlugin: function(/*Context*/ctx) {
			// summary: only display the action on Shape Size Chart
			var cache = ctx.cache;
			var sizeChart = cache.getNode(ctx.getContextNode().__Parent__);
			var parent = cache.getNode(sizeChart.__Parent__);
			return parent && parent.$Type == "Shape";
		}
	});
});